/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetLodgingSummaryQueryResponse,
  GetLodgingSummaryQueryParams,
} from '../types/GetLodgingSummary'

function getGetLodgingSummaryUrl() {
  const res = { method: 'GET', url: `/api/v1/places/lodging/summary/` as const }
  return res
}

/**
 * @summary Lodging chains summary counts
 * {@link /api/v1/places/lodging/summary/}
 */
export async function getLodgingSummary(
  params?: GetLodgingSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetLodgingSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetLodgingSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
